import React, { useEffect, useState } from 'react';
import FormView from '../../components/views/formView';
import { HOME as SURVEYLIST } from '../../../routes/paths';
import { useNavigate } from 'react-router-dom';
import { MasterMessage } from '../../../masters/masterMessages';
import StepperGeneral from '../../components/general/stepper/stepper';
import SurveyInformation from './steps/surveyInformation';
import SurveyQuestions from './steps/surveyQuestions';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { typesRedux as types } from '../../../shared/types/typesRedux';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ProjectsList } from '../../../shared/types/project.interface';
import HistoryIcon from '@mui/icons-material/History';
import { SurveyHistoricalModal } from './historicalSurvey';
import { Box } from '@mui/material';
import {
    QuestionHistorical,
    SurveyHistorical,
} from '../../../shared/types/survey.interface';
import {
    asyncGetQuestionHistorical,
    asyncGetSurveyHistorical,
} from '../../../services/survey.service';
import { QuestionHistoricalModal } from './historicalQuestion';

type Props = {
    idSurvey?: any;
    surveyInfo?: any;
    onSave?: any;
    projects?: ProjectsList[];
};

const SurveyForm = ({ surveyInfo, idSurvey, onSave, projects }: Props) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { surveys }: any = MasterMessage;
    const { activeStep } = useSelector((state: RootState) => state.general);
    const [saveInfo, setSaveInfo] = useState<any>();
    const [saveQuestions, setSaveQuestions] = useState<any>();
    const [submit, setSubmit] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [openSurveyHistorical, setOpenSurveyHistorical] =
        useState<boolean>(false);
    const [surveyHistorical, setSurveyHistorical] =
        useState<SurveyHistorical[]>();
    const [openQuestionHistorical, setOpenQuestionHistorical] = useState(false);
    const [questionHistorical, setQuestionHistorical] =
        useState<QuestionHistorical[]>();

    useEffect(() => {
        if (openSurveyHistorical && activeStep === 0) {
            setSurveyHistorical(undefined);
            setLoading(true);
            asyncGetSurveyHistorical(idSurvey)
                .then((resp) => {
                    if (resp) setSurveyHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [openSurveyHistorical, activeStep]);

    useEffect(() => {
        if (openQuestionHistorical && activeStep === 1) {
            setQuestionHistorical(undefined);
            setLoading(true);
            asyncGetQuestionHistorical(idSurvey)
                .then((resp) => {
                    if (resp) setQuestionHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [openQuestionHistorical, activeStep]);

    const steps = [
        {
            label: 'Datos Encuesta',
            component: (
                <SurveyInformation
                    projects={projects}
                    surveyInfo={surveyInfo}
                    idSurvey={idSurvey}
                    onSubmitSave={(value: any) => setSubmit(value)}
                    saveInfo={setSaveInfo}
                    onSave={(value: any) => onSave(value)}
                />
            ),
        },
        {
            label: 'Preguntas Y Respuestas',
            component: (
                <SurveyQuestions
                    idSurvey={idSurvey}
                    saveQuestions={setSaveQuestions}
                />
            ),
        },
    ];

    const onClickAdditionalActionButton = () => {
        if (activeStep === 0) {
            setOpenSurveyHistorical(!openSurveyHistorical);
        }
        if (activeStep === 1) {
            setOpenQuestionHistorical(!openQuestionHistorical);
        }
    };

    return (
        <>
            <FormView
                title={idSurvey ? surveys.titleEdit : surveys.titleNew}
                disableAdd={true}
                enabledAddLoading={true}
                titleButtonLoading={
                    activeStep === 0 ? 'Siguiente' : 'Agregar Pregunta'
                }
                loadingPositionButtonLoading="start"
                startIconButtonLoading={
                    activeStep === 0 ? <ArrowForwardIcon /> : <AddCircleIcon />
                }
                loadingButtonLoading={submit}
                disabledLoadingButton={submit}
                onClickButtonLoading={
                    activeStep === 0 ? saveInfo : saveQuestions
                }
                onClickBack={
                    activeStep === 0
                        ? () => navigate(SURVEYLIST)
                        : () => dispatch({ type: types.backStepper })
                }
                additionalActionButton
                additionalActionTitle="Histórico"
                additionalActionIcon={<HistoryIcon />}
                onClickAdditionalActionButton={onClickAdditionalActionButton}
            />
            <StepperGeneral steps={steps} />
            {openSurveyHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <SurveyHistoricalModal
                        historical={surveyHistorical ?? []}
                        open={openSurveyHistorical}
                        setOpen={setOpenSurveyHistorical}
                        loading={loading}
                    />
                </Box>
            )}
            {openQuestionHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <QuestionHistoricalModal
                        historical={questionHistorical ?? []}
                        open={openQuestionHistorical}
                        setOpen={setOpenQuestionHistorical}
                        loading={loading}
                    />
                </Box>
            )}
        </>
    );
};

export default SurveyForm;
